<script setup>
// Aviso de Uso Limitado exigido pelo Google nas telas que pedem acesso às APIs do
// Google Workspace (Google Agenda e caixa de e-mail do Google).
const PRIVACY_POLICY_URL = 'https://talkvia.com.br/politica-de-privacidade';
</script>

<template>
  <aside
    class="flex items-start gap-3 rounded-lg border border-n-weak bg-n-solid-1 p-3"
    data-testid="google-limited-use"
  >
    <span
      class="i-hugeicons-shield-01 mt-0.5 size-4 shrink-0 text-n-slate-11"
      aria-hidden="true"
    />
    <div class="min-w-0">
      <p class="mb-1 text-sm font-medium text-n-slate-12">
        {{ $t('GOOGLE_LIMITED_USE.TITLE') }}
      </p>
      <p class="mb-1 text-xs leading-5 text-n-slate-11">
        {{ $t('GOOGLE_LIMITED_USE.TEXT') }}
      </p>
      <a
        :href="PRIVACY_POLICY_URL"
        target="_blank"
        rel="noopener noreferrer"
        class="text-xs font-medium text-n-blue-11 underline underline-offset-2"
      >
        {{ $t('GOOGLE_LIMITED_USE.PRIVACY_POLICY') }}
      </a>
    </div>
  </aside>
</template>
